export const AVA_AI_DISPLAY_NAME = 'Talos AI';
export const AVA_AI_WIDTH = 440;
export const AVA_AI_POPOUT_WIDTH = 440;
export const AVA_AI_POPOUT_HEIGHT = 700;
export const AVA_AI_SHORTCUT_KEY = { key: 'i', metaKey: true };
export const AVA_AI_SHORTCUT_LABEL = '⌘I';
// Must not collide with any OMS_POPOUT_GROUP_VIEWS group name (the value passed to window.open).
export const AVA_AI_POPOUT_WINDOW_NAME = 'AvaAI';
export const AVA_AI_COMPOSER_INPUT_ID = 'ava-ai-composer-input';
